
export class DateUtils
{
	public static getCurrentDateString()
	{
		var now = new Date();

		/*
		if (now.toLocaleDateString)
		{
			var result = now.toLocaleDateString();
			result = result.split("/").join("-");
			return result;
		}
		*/

		return (now.getMonth()+1) + "-" + now.getDate() + "-" + now.getFullYear();
	}
}